import { render } from "./RealTimeEmailDetails.vue?vue&type=template&id=a3601c70&scoped=true"
import script from "./RealTimeEmailDetails.vue?vue&type=script&lang=js"
export * from "./RealTimeEmailDetails.vue?vue&type=script&lang=js"

import "./RealTimeEmailDetails.vue?vue&type=style&index=0&id=a3601c70&scoped=true&lang=css"

import exportComponent from "/usr/frontend/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3601c70"]])

export default __exports__